import React from 'react'

function MessageIcon2({ size, ...props }) {
  return (
    // <svg
    //   width={size || '20'}
    //   height={size || '20'}
    //   viewBox='0 0 24 24'
    //   strokeWidth='2'
    //   stroke='currentColor'
    // fill='currentColor' // Changed to fill the shape like the image
    //   strokeLinecap='round'
    //   strokeLinejoin='round'
    //   {...props}
    // >
    //   <path stroke='none' d='M0 0h24v24H0z' fill='none' />
    //   <path d='M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z' />{' '}
    //   {/* Circle for the bubble */}
    //   <path d='M7.5 16.5l-4.5 4.5v-4.5h4.5z' />{' '}
    //   {/* Tail of the speech bubble */}
    // </svg>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size || '24'}
      height={size || '24'}
      viewBox='0 -960 960 960'
      fill='currentColor'
      {...props}
    >
      <path d='M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z' />
    </svg>
  )
}

export default MessageIcon2
